module.exports = __webpack_public_path__ + "img/lux color chart.f06438a5.png";